/**
 * Get Data.
 * Funcations for getting and structuring menu api data.
 *
 * @format
 */

import { useEffect, useState } from 'react';
import axios from 'axios';
import { safeUrl } from '@services/drupal-services';

/**
 * Get Data.
 *
 * @param {string} apiEndpoint
 * @return {Object}
 */
export const useFetchData = (apiEndpoint) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(safeUrl(apiEndpoint, true))
      .then((result) => {
        setData(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [apiEndpoint]);

  return data;
};
